"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWalletsBalance = void 0;
const tslib_1 = require("tslib");
const toNumber_1 = require("./toNumber");
const axios_1 = tslib_1.__importDefault(require("axios"));
const instance = axios_1.default.create({
    baseURL: 'https://api.coingecko.com/api/v3/coins'
});
const ethCurrencies = ['eth', 'dai', 'usdc', 'usdt'];
const ethContractAddresses = [
    { address: '0x6b175474e89094c44da98b954eedeac495271d0f', name: 'dai' },
    { address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48', name: 'usdc' },
    { address: '0xdac17f958d2ee523a2206206994597c13d831ec7', name: 'usdt' }
];
const celoCurrencies = ['celo', 'cusd', 'ceur'];
const celoContractAddresses = [
    { address: '0x471EcE3750Da237f93B8E339c536989b8978a438', name: 'celo' },
    { address: '0x765DE816845861e75A25fCA122bb6898B8B1282a', name: 'cusd' },
    { address: '0xD8763CBa276a3738E6DE85b4b3bF5FDed6D6cA73', name: 'ceur' }
];
const getCoinPrice = async (coin) => (await instance.get(`/${coin}?tickers=false&community_data=false&developer_data=false&sparkline=false`)).data.market_data.current_price.usd;
const getEtherScanBalance = async (wallet, etherscanApiKey, balanceOf) => {
    var _a;
    const contractaddress = (_a = ethContractAddresses.find(({ name }) => name === balanceOf)) === null || _a === void 0 ? void 0 : _a.address;
    const queryCoin = contractaddress ? `action=tokenbalance&contractaddress=${contractaddress}` : 'action=balance';
    const balance = await axios_1.default.get(`https://api.etherscan.io/api?module=account&${queryCoin}&address=${wallet}&tag=latest&apikey=${etherscanApiKey}`);
    if (balanceOf === 'eth') {
        return (0, toNumber_1.toNumber)(balance.data.result);
    }
    return parseInt(balance.data.result, 10) / 1000000;
};
const getCeloApiBalance = async (wallet, balanceOf) => {
    var _a;
    const contractaddress = (_a = celoContractAddresses.find(({ name }) => name === balanceOf)) === null || _a === void 0 ? void 0 : _a.address;
    const balance = await axios_1.default.get(`https://explorer.celo.org/api?module=account&action=tokenbalance&contractaddress=${contractaddress}&address=${wallet}`);
    return balance.data.result;
};
const getCeloWalletBalance = async (wallet) => {
    const [celoPrice, celoEuroPrice] = await Promise.all([getCoinPrice('celo'), getCoinPrice('celo-euro')]);
    const balance = await Promise.all(celoCurrencies.map(async (currency) => {
        const val = await getCeloApiBalance(wallet, currency);
        if (currency === 'celo') {
            return celoPrice * (0, toNumber_1.toNumber)(val);
        }
        if (currency === 'ceur') {
            return celoEuroPrice * (0, toNumber_1.toNumber)(val);
        }
        return (0, toNumber_1.toNumber)(val);
    }));
    return balance.reduce((previous, current) => previous + current, 0);
};
const getEthereumWalletBalance = async (wallet, etherscanApiKey) => {
    const ethPrice = await getCoinPrice('ethereum');
    const balance = await Promise.all(ethCurrencies.map(async (currency) => {
        const val = await getEtherScanBalance(wallet, etherscanApiKey, currency);
        return currency === 'eth' ? ethPrice * val : val;
    }));
    return balance.reduce((previous, current) => previous + current, 0);
};
async function getWalletsBalance(props) {
    const [celo, ethereum] = await Promise.all([
        getCeloWalletBalance(props.wallets.celo),
        getEthereumWalletBalance(props.wallets.ethereum, props.etherscanApiKey)
    ]);
    return { celo, ethereum };
}
exports.getWalletsBalance = getWalletsBalance;
//# sourceMappingURL=wallets.js.map